import PeTypography from '@pe-libs/react-components/build/components/PeTypography';
import React, { FC } from 'react';
import useStyles from '../styles';

type Props = {
  title?: string;
  desc?: string;
};

const PeOnboardingIntro: FC<Props> = ({ title, desc }) => {
  const styles = useStyles();

  return (
    <>
      {title && (
        <PeTypography variant="h3" className={styles.mainTitle}>
          {title}
        </PeTypography>
      )}
      {desc && (
        <PeTypography variant="body1" className={styles.mainDesc}>
          {desc}
        </PeTypography>
      )}
    </>
  );
};

export default PeOnboardingIntro;
